import { AdminShell } from "@project/admin/components/admin-shell";
import { ApiResourceTable } from "@project/admin/components/api-resource-table";
import { DonorFormFields } from "@project/admin/components/donations/donor-form-fields";
import type { Field } from "@project/admin/components/resource-table";
import { donationDonorService } from "@project/services/admin/donation-donor.service";
import {
  buildDonationDonorPayload,
  mapDonationDonorToForm,
  type DonationDonorPayload,
  type DonationDonorRecord,
} from "@project/types/donation-donor";

const tableFields: Field[] = [
  {
    name: "name",
    label: "Full Name",
    showInTable: true,
    hidden: true,
  },
  {
    name: "phone",
    label: "Mobile",
    showInTable: true,
    hidden: true,
  },
  {
    name: "email",
    label: "Email",
    showInTable: true,
    hidden: true,
  },
  {
    name: "organization",
    label: "Organization",
    showInTable: true,
    hidden: true,
  },
  {
    name: "city_name",
    label: "City",
    showInTable: true,
    hidden: true,
  },
  {
    name: "donation_type",
    label: "Donation Type",
    showInTable: true,
    hidden: true,
  },
];

export default function Page() {
  return (
    <AdminShell title="Donors" subtitle="Donor master list">
      <ApiResourceTable<DonationDonorRecord>
        title="Donor"
        labelField="name"
        fields={tableFields}
        searchFields={["name", "phone", "email", "organization", "city_name"]}
        enableCsvExport
        csvFileName="donors"
        dialogClassName="max-w-3xl"
        addButtonLabel="Add Donor"
        list={query => donationDonorService.listPage(query)}
        create={payload =>
          donationDonorService.create(payload as DonationDonorPayload)
        }
        update={(id, payload) =>
          donationDonorService.update(id, payload as DonationDonorPayload)
        }
        remove={id => donationDonorService.delete(id)}
        removeChild={(parentId, childId, parent) =>
          donationDonorService
            .removeChild(parentId, childId, parent)
            .then(() => undefined)
        }
        renderForm={({ editing, setEditing }) => (
          <DonorFormFields editing={editing} setEditing={setEditing} />
        )}
        buildPayload={editing =>
          editing
            ? buildDonationDonorPayload(editing as Record<string, unknown>)
            : null
        }
        mapRecordToForm={record =>
          mapDonationDonorToForm(record) as Partial<DonationDonorRecord>
        }
      />
    </AdminShell>
  );
}
